























import Vue from "vue";
import { mapState } from "vuex";
import { Component, Prop } from "vue-property-decorator";

// Types
import { ICountry, IRegion } from "@/models/constants";

// Constant Data
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      regions(state: IState, getters) {
        return getters[`constants/getRegions`](
          this.$_.get(this.country, "code")
        );
      }
    })
  }
})
export default class RegionField extends Vue {
  // getters
  public regions!: IRegion[];

  @Prop({ required: true })
  public value!: string | null;

  @Prop({ required: true })
  public country!: ICountry;

  @Prop({ required: true })
  public disabled!: boolean;

  public get regionId() {
    return this.value;
  }

  public set regionId(value) {
    this.$emit("input", value);
  }
}
